import { render, staticRenderFns } from "./SafetyStatementsCreate.vue?vue&type=template&id=17a578cb&scoped=true"
import script from "./SafetyStatementsCreate.vue?vue&type=script&lang=js"
export * from "./SafetyStatementsCreate.vue?vue&type=script&lang=js"
import style0 from "./SafetyStatementsCreate.vue?vue&type=style&index=0&id=17a578cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a578cb",
  null
  
)

export default component.exports